module.exports = __webpack_public_path__ + "files/SPIADI2022 - Rapport National provisoire - juillet 2023.f1c6bbc6102c992806cb30ebe079ea8d.pdf";